import { z } from 'zod';
import { addIssue } from './helpers/add-issue';
import { validateUnitPreset } from './helpers/unit-preset-validator';
import { ISimulationPayload } from '../types';

export const validateStep2BaseScenario = (
  data: ISimulationPayload,
  ctx: {
    addIssue: (issue: z.IssueData) => void;
  },
  energyPricesProjection?: Record<string, number> | null,
  marginFeeProjection?: Record<string, number> | null,
): boolean => {
  let hasErrors = false;
  const baseScenario = data.inputs?.parsedPayload?.baseScenario;
  const useDifferentPeriodsByUnit = data.inputs?.parsedPayload?.aux__useDifferentPeriodsByUnit ?? false;

  if (!baseScenario) {
    addIssue(ctx, ['inputs', 'parsedPayload', 'baseScenario'], 'Cenário base é obrigatório');
    return false;
  }

  const scenarioPayload = baseScenario.scenarioPayload;
  const globalSupplyStartDate = data.inputs?.parsedPayload?.aux__useGlobalSupplyStartDate;
  const globalSupplyFinalDate = data.inputs?.parsedPayload?.aux__useGlobalSupplyFinalDate;

  if (!scenarioPayload || scenarioPayload.length === 0) {
    addIssue(
      ctx,
      ['inputs', 'parsedPayload', 'baseScenario', 'scenarioPayload'],
      'Pelo menos uma unidade é obrigatória',
    );
    return false;
  }

  scenarioPayload.forEach((unitPreset, unitIndex) => {
    const basePath = ['inputs', 'parsedPayload', 'baseScenario', 'scenarioPayload', unitIndex];
    const isValid = validateUnitPreset({
      unitPreset,
      basePath,
      ctx,
      useDifferentPeriodsByUnit,
      globalSupplyStartDate,
      globalSupplyFinalDate,
      energyPricesProjection,
      marginFeeProjection,
    });
    if (!isValid) hasErrors = true;
  });

  const nicknameCount = new Map<string, number[]>();
  scenarioPayload.forEach((unitPreset, unitIndex) => {
    const nickname = unitPreset?.unitPayload?.nickname?.trim().toLowerCase();
    if (nickname) {
      const indices = nicknameCount.get(nickname) ?? [];
      indices.push(unitIndex);
      nicknameCount.set(nickname, indices);
    }
  });

  nicknameCount.forEach((indices) => {
    if (indices.length > 1) {
      indices.forEach((unitIndex) => {
        addIssue(
          ctx,
          ['inputs', 'parsedPayload', 'baseScenario', 'scenarioPayload', unitIndex, 'unitPayload', 'nickname'],
          'Já existe uma unidade com este nome',
        );
      });
      hasErrors = true;
    }
  });

  return !hasErrors;
};
